export default function parseRss(rss) {
    var _a, _b, _c;
    const xml = new DOMParser().parseFromString(rss, 'text/xml');
    return {
        eyebrow: (_a = parseEyebrow(xml)) !== null && _a !== void 0 ? _a : '',
        imageUrl: parseImageUrl(xml),
        title: (_b = parseTitle(xml)) !== null && _b !== void 0 ? _b : '',
        url: (_c = parseUrl(xml)) !== null && _c !== void 0 ? _c : ''
    };
}
function parseEyebrow(xml) {
    const categories = [];
    xml
        .querySelectorAll('item > category')
        .forEach((node) => node.textContent && categories.push(node.textContent));
    return categories.length ? categories.join(' | ') : undefined;
}
function parseImageUrl(xml) {
    var _a, _b, _c;
    const htmlString = (_a = xml.querySelector('item > description')) === null || _a === void 0 ? void 0 : _a.textContent;
    if (!htmlString)
        return undefined;
    const html = new DOMParser().parseFromString(htmlString, 'text/html');
    return (_c = (_b = html.querySelector('img')) === null || _b === void 0 ? void 0 : _b.getAttribute('src')) === null || _c === void 0 ? void 0 : _c.split('?')[0];
}
function parseTitle(xml) {
    var _a, _b;
    return (_b = (_a = xml.querySelector('item > title')) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.split(' | ')[0];
}
function parseUrl(xml) {
    var _a;
    return (_a = xml.querySelector('item > link')) === null || _a === void 0 ? void 0 : _a.textContent;
}
//# sourceMappingURL=parseRss.js.map